import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Loads functional usage whenever the current space record changes.
 */
export const loadForCurrentEntityOnEntityChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins.currentEntityPlugin.feature.selectors
      .getId()
      .asObservable.pipe(
        rxjs.distinctUntilChanged(),
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from('(effect) load for current entity on entity change')
            .create(),
        ),
      ),
)
